import { render } from "./LichensHomeView.vue?vue&type=template&id=2883ac1d"
import script from "./LichensHomeView.vue?vue&type=script&lang=js"
export * from "./LichensHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__